import React from 'react';

export default function Hero() {
  return (
    <div className="position-relative bg-gradient pt-5" style={{ background: 'linear-gradient(to right, #1E40AF, #1E3A8A)' }}>
      <div className="position-absolute bottom-0 w-100 bg-white" style={{ height: '50px', transform: 'skewY(-4deg)', transformOrigin: 'bottom right' }}></div>
    </div>
  );
}
